import { createContext, useContext, useState, useEffect, useCallback } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const UploadedImagesContext = createContext({ images: [], loading: true });

export function UploadedImagesProvider({ children }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API}/api/images`);
        if (res.ok) {
          const data = await res.json();
          if (!cancelled) setImages(data);
        }
      } catch (err) { console.error("Failed to load uploaded images:", err); }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <UploadedImagesContext.Provider value={{ images, loading }}>
      {children}
    </UploadedImagesContext.Provider>
  );
}

export function useUploadedImages() {
  const { images, loading } = useContext(UploadedImagesContext);

  const getImages = useCallback((unitId, category) =>
    images
      .filter(img => (!unitId || img.unit_id === unitId) && (!category || img.category === category))
      .map(img => `${API}/api/files/${img.storage_path}`),
  [images]);

  const getUnitImages = useCallback((unitId) =>
    images
      .filter(img => img.unit_id === unitId)
      .map(img => `${API}/api/files/${img.storage_path}`),
  [images]);

  const getAllGallery = useCallback(() =>
    images
      .filter(img => img.category === "gallery" || img.category === "exterior" || img.category === "rooms")
      .map(img => `${API}/api/files/${img.storage_path}`),
  [images]);

  return { images, loading, getImages, getUnitImages, getAllGallery };
}
